// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2uzA7","filesListContainer":"PosDisputesFiles_filesListContainer__2w0KF","filesButton":"PosDisputesFiles_filesButton__31iyb"};